<div   class="inp_tel fz_s pos_relative">
  <input
    [(ngModel)]="formattedPhone"
    (ngModelChange)="onChangeCustomerPhone()"
    [name]="name"
    (input)="onChangeInputTel()"
    [mask]="selectedPhoneCode?.example"
    [showMaskTyped]="true"
    [dropSpecialCharacters]="false"
    [prefix]="selectedPhoneCode?.dialCode"
    type="text"
    class="inp"
  />

  <div (click)="toggleDropdown()" class="selected_country cursor_pointer">
    {{ selectedPhoneCode?.name }}
  </div>
  <div *ngIf="isFocusedInput" class="dropdown card">
    <ul class="country_list">
      <li
        *ngFor="let country of countries; let i = index"
        (click)="selectPhoneCode(i)"
        class="country row_hover cursor_pointer"
      >
        <div class="row">
          <span>{{ country.name }}</span>
          <span>{{ country.dialCode }}</span>
        </div>
      </li>
    </ul>
  </div>
  <button *ngIf="phoneValue" (click)="copyTextToClipboard($event)" type="button" class="cursor_pointer btn_copy">
    <span *ngIf="!copiedTooltipVisible" class="material-symbols-outlined fz_l">
        content_copy
    </span>
    <span *ngIf="copiedTooltipVisible" class="material-symbols-outlined fz_l">
      check
    </span>
  </button>
</div>
